import { mapGetters } from "vuex";
import ElMap from "@/components/study/editor/elements/el-map";
import ElTextarea from "@/components/study/editor/elements/el-textarea";
import ElProgressSlider from "@/components/study/editor/elements/el-progress-slider";
import ElMeanSlider from "@/components/study/editor/elements/el-mean-slider";
import ElImage from "@/components/study/editor/elements/el-image";
import ElClosedQuestion from "@/components/study/editor/elements/el-closed-question";
import ElTable from "@/components/study/editor/elements/el-table";
import ElSquare from "@/components/study/editor/elements/el-square";
import ElSelect from "@/components/study/editor/elements/el-select";
import ElLineChart from "@/components/study/editor/elements/el-line-chart";
import ElRowPrice from "@/components/study/editor/elements/el-row-price";
import ElBarDashChart from "@/components/study/editor/elements/el-bar-dash-chart";
import ElOperationsReference from "@/components/study/editor/elements/el-operations-reference";
import ElCheckbox from "@/components/study/editor/elements/el-checkbox";
import ElCheckboxNumber from "@/components/study/editor/elements/el-checkbox-number";
import ElPromoVolumePrix from "@/components/study/editor/elements/el-promo-volume-prix";
import ElPromoDureeCommercialisation from "@/components/study/editor/elements/el-promo-duree-commercialisation";
import ElTitle from "@/components/study/editor/elements/el-title";
import ElEditMode from "@/components/study/editor/elements/el-edit-mode";
import error from "@/components/global/error.vue";

const PageMixin = {
	data: function () {
		return {

		};
	},
	computed: {
		...mapGetters(["active_study"]),
	},
	methods: {
		moneyParse (value){
			value = value.toString();
			let decimalPart = "";
			if(value.includes(".")){
				// remove the decimal part before the parsing
				decimalPart = value.slice(value.indexOf("."));
				value = value.slice(0,value.indexOf("."));
			}
			value = value.split("").reverse().join("");
			let newValue = "";
			for(let i = 0 ; i < value.length ; i++){
				if(i % 3 == 0 && i != 0){
					newValue += " ";
				}
				newValue += value[i];
			}
			value = newValue;
			value = value.split("").reverse().join("");
			if(decimalPart !== ""){
				value += decimalPart;
			}
			return value;
		},
		to_percent (v) {
			if (v && v != "-") {
				// console.log('to percent', v);
				return this.$options.filters.percent(this.$options.filters.to_float(v));
			}
			return v;
		},
	},
	components: {
		ElMap,
		ElTextarea,
		ElProgressSlider,
		ElMeanSlider,
		ElImage,
		ElClosedQuestion,
		ElTable,
		ElSquare,
		ElSelect,
		ElLineChart,
		ElRowPrice,
		ElBarDashChart,
		ElOperationsReference,
		ElCheckbox,
		ElCheckboxNumber,
		ElPromoVolumePrix,
		ElPromoDureeCommercialisation,
		ElTitle,
		ElEditMode,
		error
	},
	filters: {
		uppercase (s) {
			return s.toUpperCase();
		},
		to_int: (value) => {
			if (typeof (value) == "string" && value.trim() == "-") {
				return value;
			}
			const v = parseInt(value);
			if (isNaN(v)) {
				return "-";
			}
			return v;
		},
		to_float: (value) => {
			let v = value;
			if (typeof (v) == "string") {
				v = v.replace(",", ".");
				v = parseFloat(v);
			}
			return v;
		},
		percent: function (value) {
			if (!value) return "";
			if (typeof (value) != "number") return value;
			const new_value = Math.round(value * 100);
			return `${new_value} %`;
		},
		loyer: (value) => {
			if (!value) return "";
			const v = parseInt(value);
			if (typeof (v) != "number") return value;
			return Math.round(v * 0.25);
		},
		euro: (value) => {
			if (!value) return "";
			const v = parseInt(value);
			if (typeof (v) != "number") return value;

			let s = String(v);
			let new_value = "";
			while (s.length > 3) {
				// console.log('s before', s, 'new_value', new_value);
				new_value += " " + s.substr(s.length - 3);
				s = s.substr(0, s.length - 3);
				// console.log('s after', s, 'new_value', new_value);
			}
			new_value = s + new_value;
			new_value = new_value.trim() + " €";
			return new_value;
		},
	},
};

export default PageMixin;